import { createAddressButtonStyles } from "@insite/content-library/Widgets/Addresses/CreateAddressButton";
import { css } from "styled-components";

createAddressButtonStyles.createNewAddressButton = {
    css: css`
        font-family: "Roboto-Medium";
    `,
};
